<!-- eslint-disable -->
<template>
  <CommonPages id="categories" :class="['categories']" titlePrefix="Categories"
    :metaDescription="domainConfig?.['meta']?.des || 'Browse books by categories'"
    header-theme="dark">

    <!-- 主要内容区域 -->
    <div class="categories-content">
      <AdComponent v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.list_top"
        ref="ads-list-top" class=" m_padding" :ads="adsensConfig?.list_top"
        :showDebug="showDebug" />
      <div class="categories-main-container"
        :class="{'categories-main-container--mobile': deviceType === 'mobile'}">
        <!-- 左侧/顶部 类别导航 -->
        <div class="category-nav-wrapper"
          :class="{'category-nav-wrapper--mobile': deviceType === 'mobile'}">
          <div class="category-nav-container">
            <div class="category-items" ref="categoryItems" @scroll="checkScrollPosition">
              <div v-for="category in categories" :key="category.value" class="category-item"
                :class="{active: activeCategory === category.value}"
                @click="selectCategory(category.value)" :data-category="category.value">
                <div class="category-item__icon-wrapper">
                  <img :src="getCategoryIcon(category.displayName)" class="category-item__icon"
                    alt="icon">
                </div>
                <span>{{ category.displayName }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧 图书列表 -->
        <div class="category-books">
          <div v-if="loading" class="category-books__loading">
            <div class="loader"></div>
            <p>Loading...</p>
          </div>
          <div v-else-if="books.length === 0" class="category-books__empty">
            <p>No books found in this category</p>
          </div>
          <div v-else class="category-books__list">
            <template v-for="(book, index) in books">
              <BookCard class="category-books__book" :key="'cat-book-v3-'+book.id" :book="book"
                layout="cover-hover" @click="goToDetail(book)" />

              <AdComponent
                v-if="deviceType == 'mobile' && $global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories && shouldInsertAdDeviece('categories',index) != -1"
                :key="`ad_cat_mobile_${index}`" :ref="'ads-cat-insert-1-' + index" class="m_100"
                :ads="adsensConfig?.categories?.[shouldInsertAdDeviece('categories',index)]"
                :showDebug="showDebug" />
              <AdComponent
                v-if="deviceType != 'mobile' && $global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories && shouldInsertAdDeviece('categoriesPC',index) != -1"
                :key="`ad_cat_pc_${index}`" :ref="'ads-cat-insert-1-' + index" class="pc_100"
                :ads="adsensConfig?.categories?.[shouldInsertAdDeviece('categoriesPC',index)]"
                :showDebug="showDebug" />
            </template>
          </div>

          <!-- 分页导航 -->
          <div class="category-pagination" v-if="deviceType !== 'mobile'">
            <img src="@/assets/vector-left.svg" alt="Previous" @click="prevPage"
              :class="{'disabled': currentPage === 1}" class="category-pagination__arrow">
            <div class="category-pagination__dots">
              <span v-for="page in totalPages" :key="page" class="category-pagination__dot"
                :class="{'active': page === currentPage}" @click="goToPage(page)"></span>
            </div>
            <img src="@/assets/vector-right.svg" alt="Next" @click="nextPage"
              :class="{'disabled': currentPage === totalPages}" class="category-pagination__arrow">
          </div>

          <!-- 移动端滚动加载提示 -->
          <div v-if="deviceType === 'mobile' && books.length > 0" class="mobile-load-more">
            <div v-if="loadingMore" class="mobile-load-more__loading">
              <div class="loader-spinner"></div>
              <span>Loading more...</span>
            </div>
            <div v-else-if="currentPage >= totalPages" class="mobile-load-more__end">
              <span>No more books</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import AdComponent from '@/pages/components/AdComponent.vue'
import CommonPages from '@/pages/components/page_common.vue'
import BookCard from '@/components/BookCard.vue'
import { mapGetters } from 'vuex'
import '@/css/categories.scss'

export default {
  name: 'Categories',
  components: {
    CommonPages,
    AdComponent,
    BookCard
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      activeCategory: 'all',
      loading: false,
      loadingMore: false,
      books: [],
      currentPage: 1,
      totalPages: 1,
      booksPerPage: 25,
      isFirstVisible: true,
      isLastVisible: false
    }
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
      'categories',
      'showDebug',
      'getCategoryByValue'
    ]),
    categoryDisplayName () {
      const category = this.getCategoryByValue(this.activeCategory)
      return category ? category.displayName : 'all'
    }
  },
  props: {
    categoriType: {
      type: String,
      default: ''
    },
  },
  async mounted () {
    console.log('fdsafdasfa');
    console.log(this.categoriType);

    // await this.initAdSystem();
    // // 确保在广告系统初始化后再初始化跟踪
    // this.$nextTick(() => {
    //   this.initAdTracking();
    // });

    // 确保分类数据加载完成，以便导航栏可以正确渲染和滚动
    await this.ensureCategoriesLoaded();

    if (this.categoriType) {
      this.activeCategory = this.categoriType;
      this.fetchCategoryBooks(this.categoriType);
    } else {
      this.activeCategory = 'all';
      this.fetchCategoryBooks('all');
    }
    // 初始加载时检查滚动状态
    this.$nextTick(() => {
      // 由于已经在watch中处理了categoriType参数，这里不需要重复调用
      this.checkScrollPosition();
      window.addEventListener('resize', this.checkScrollPosition);

      // 监听设备方向变化事件，在方向变化时重新滚动到选中分类
      if (this.deviceType === 'mobile') {
        window.addEventListener('orientationchange', this.handleOrientationChange);
      }

      // 直接滚动到选中的分类，无需延迟和动画
      this.scrollActiveCategoryIntoView();
    });

    // 监听全局滚动事件用于加载更多
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkScrollPosition);
    window.removeEventListener('scroll', this.handleScroll);
    // 移除方向变化监听器
    if (this.deviceType === 'mobile') {
      window.removeEventListener('orientationchange', this.handleOrientationChange);
    }
  },
  methods: {
    getCategoryIcon (displayName) {
      try {
        return require(`@/assets/category-${displayName}.svg`);
      } catch (e) {
        // Fallback to a default icon (e.g. Biography)
        return require(`@/assets/category-Biography.svg`);
      }
    },
    // 确保分类数据已经加载
    async ensureCategoriesLoaded () {
      // 检查分类数据是否已加载
      if (!this.$store.getters.categoriesLoaded) {
        try {
          // 等待分类数据加载完成
          await new Promise(resolve => {
            const checkCategoriesLoaded = () => {
              if (this.$store.getters.categoriesLoaded) {
                resolve();
              } else {
                setTimeout(checkCategoriesLoaded, 100);
              }
            };
            checkCategoriesLoaded();
          });
        } catch (error) {
          console.error('等待分类数据加载失败:', error);
        }
      }
      return Promise.resolve();
    },
    shouldInsertAdDeviece (pos, index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      // 在移动端检查位置是否在配置中，返回在配置数组中的索引
      // 例如：如果 position 是 1，且 adPosConfig[pos] 是 [1, 2]，则返回 0
      // 如果 position 是 2，且 adPosConfig[pos] 是 [1, 2]，则返回 1
      console.log(this.adPosConfig?.[pos]);
      console.log(position);
      const adIndex = this.adPosConfig?.[pos].indexOf(position);
      // 返回广告在配置中的索引位置，如果不在配置中则返回 -1
      return adIndex;
    },
    // 获取指定类别的图书 - 简化版本
    async fetchCategoryBooks (categoryValue) {
      this.loading = true;
      this.currentPage = 1;

      try {
        // 确保categories数据已经加载完成
        if (!this.$store.getters.categoriesLoaded) {
          await new Promise(resolve => {
            const checkCategoriesLoaded = () => {
              if (this.$store.getters.categoriesLoaded) {
                resolve();
              } else {
                setTimeout(checkCategoriesLoaded, 100);
              }
            };
            checkCategoriesLoaded();
          });
        }

        // 在确保数据已加载的情况下获取分类信息
        // 我们不使用 categoryObj，但保留注释以解释这里的逻辑
        const categoryObj = this.getCategoryByValue(categoryValue);
        const categoryName = categoryObj ? categoryObj.displayName : '';

        // 调用API获取分类图书
        const response = await this.$global.server.getCategoriesSearchList({
          novelLang: 'en',
          novelType: categoryValue !== 'all' ? categoryName : '',
          pageSize: this.booksPerPage,
          pageNum: this.currentPage
        });

        if (response && response.success && response.data && response.data.novelList) {
          // 处理API返回数据
          const bookList = response.data.novelList.map(book => ({
            id: book.id || book.novelId,
            title: book.novelName || '',
            author: book.novelAuthorName || '',
            coverImage: book.bigImg || '',
            category: book.novelType || '',
            novelId: book.novelId || '',
            rating: book.novelScoreStr || ''
          }));

          // 更新书籍列表和总页数
          this.books = bookList;
          this.totalPages = response.data.total ?
            Math.max(1, Math.ceil(response.data.total / this.booksPerPage)) : 1;
        } else {
          this.books = [];
          this.totalPages = 1;
          console.warn('无法获取分类数据');
        }
      } catch (error) {
        console.error('获取分类图书失败:', error);
        this.books = [];
        this.totalPages = 1;
      } finally {
        this.loading = false;
      }
    },

    // 选择分类 - 简化版本
    selectCategory (categoryValue) {
      if (this.activeCategory === categoryValue) return;

      this.activeCategory = categoryValue;
      this.fetchCategoryBooks(categoryValue);

      // 更新URL
      const channel = this.$route.params.channel;
      const newPath = channel ? `/${channel}/${categoryValue}` : `/${categoryValue}`;

      if (this.$route.path !== newPath) {
        this.$router.push(newPath);
      }

      // 在选择新分类后，滚动到该分类
      this.$nextTick(() => {
        this.scrollActiveCategoryIntoView();
      });
    },

    // 处理方向变化
    handleOrientationChange () {
      // 方向变化后立即滚动到选中分类
      setTimeout(() => {
        this.scrollActiveCategoryIntoView();
      }, 300);
    },

    // 导航控制 - 使用直接scrollLeft方式，去掉动画
    scrollLeft () {
      const container = this.$refs.categoryItems;
      if (container) {
        // 强制禁用平滑滚动
        container.style.scrollBehavior = 'auto';

        // 直接设置scrollLeft值，减少200px
        const newPosition = Math.max(0, container.scrollLeft - 200);
        container.scrollLeft = newPosition;
        // 立即检查滚动位置
        this.checkScrollPosition();
      }
    },

    scrollRight () {
      const container = this.$refs.categoryItems;
      if (container) {
        // 强制禁用平滑滚动
        container.style.scrollBehavior = 'auto';

        // 直接设置scrollLeft值，增加200px
        const maxScroll = container.scrollWidth - container.clientWidth;
        const newPosition = Math.min(maxScroll, container.scrollLeft + 200);
        container.scrollLeft = newPosition;
        // 立即检查滚动位置
        this.checkScrollPosition();
      }
    },

    checkScrollPosition () {
      const categoryItems = this.$refs.categoryItems;
      if (!categoryItems) return;

      // 确定滚动的容器
      const container = this.deviceType === 'mobile' ? categoryItems.parentElement : categoryItems;

      if (container) {
        // 移动端优化：调整边界检测的容忍度，解决某些移动浏览器的舍入问题
        const tolerance = this.deviceType === 'mobile' ? 5 : 10;
        this.isFirstVisible = container.scrollLeft <= tolerance;

        // 检查是否滚动到底部时，考虑移动设备可能存在的精度问题
        const scrollEnd = container.scrollWidth - container.clientWidth;
        this.isLastVisible = container.scrollLeft >= (scrollEnd - tolerance);

        // 在移动设备上，确保滚动状态更新的可靠性
        if (this.deviceType === 'mobile') {
          // 强制重新计算布局，确保UI状态与实际滚动位置一致
          setTimeout(() => {
            // 更新渐变覆盖层的可见性
            const leftGradient = document.querySelector('.category-gradient-overlay.left');
            const rightGradient = document.querySelector('.category-gradient-overlay.right');

            if (leftGradient) {
              leftGradient.classList.toggle('active', !this.isFirstVisible);
            }
            if (rightGradient) {
              rightGradient.classList.toggle('active', !this.isLastVisible);
            }
          }, 50);
        }
      }
    },

    // 滚动监听
    handleScroll () {
      if (this.deviceType !== 'mobile') return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (documentHeight - scrollTop - windowHeight < 200) {
        if (!this.loading && !this.loadingMore && this.currentPage < this.totalPages) {
          this.loadMore();
        }
      }
    },

    async loadMore () {
      this.loadingMore = true;
      this.currentPage++;

      try {
        // 确保categories数据已经加载完成
        if (!this.$store.getters.categoriesLoaded) {
          await new Promise(resolve => {
            const checkCategoriesLoaded = () => {
              if (this.$store.getters.categoriesLoaded) {
                resolve();
              } else {
                setTimeout(checkCategoriesLoaded, 100);
              }
            };
            checkCategoriesLoaded();
          });
        }

        const categoryObj = this.getCategoryByValue(this.activeCategory);
        const categoryName = categoryObj ? categoryObj.displayName : '';

        const response = await this.$global.server.getCategoriesSearchList({
          novelLang: 'en',
          novelType: this.activeCategory !== 'all' ? categoryName : '',
          pageSize: this.booksPerPage,
          pageNum: this.currentPage
        });

        if (response && response.success && response.data && response.data.novelList) {
          const newBooks = response.data.novelList.map(book => ({
            id: book.id || book.novelId,
            title: book.novelName || '',
            author: book.novelAuthorName || '',
            coverImage: book.bigImg || '',
            category: book.novelType || '',
            novelId: book.novelId || '',
            rating: book.novelScoreStr || ''
          }));

          this.books = [...this.books, ...newBooks];
        }
      } catch (error) {
        console.error('Load more failed:', error);
        this.currentPage--;
      } finally {
        this.loadingMore = false;
      }
    },

    // 分页控制 - 简化版本
    async prevPage () {
      if (this.currentPage <= 1) return;

      this.currentPage--;
      await this.loadPage();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    async nextPage () {
      if (this.currentPage >= this.totalPages) return;

      this.currentPage++;
      await this.loadPage();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    async goToPage (page) {
      if (page === this.currentPage) return;
      this.currentPage = page;
      await this.loadPage();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    // 加载指定页面的数据
    async loadPage () {
      this.loading = true;

      try {
        // 确保categories数据已经加载完成
        if (!this.$store.getters.categoriesLoaded) {
          await new Promise(resolve => {
            const checkCategoriesLoaded = () => {
              if (this.$store.getters.categoriesLoaded) {
                resolve();
              } else {
                setTimeout(checkCategoriesLoaded, 100);
              }
            };
            checkCategoriesLoaded();
          });
        }

        const categoryObj = this.getCategoryByValue(this.activeCategory);
        const categoryName = categoryObj ? categoryObj.displayName : '';

        const response = await this.$global.server.getCategoriesSearchList({
          novelLang: 'en',
          novelType: this.activeCategory !== 'all' ? categoryName : '',
          pageSize: this.booksPerPage,
          pageNum: this.currentPage
        });

        if (response && response.success && response.data && response.data.novelList) {
          this.books = response.data.novelList.map(book => ({
            id: book.id || book.novelId,
            title: book.novelName || '',
            author: book.novelAuthorName || '',
            coverImage: book.bigImg || '',
            category: book.novelType || '',
            novelId: book.novelId || '',
            rating: book.novelScoreStr || ''
          }));
        }
      } catch (error) {
        console.error('加载页面数据失败:', error);
      } finally {
        this.loading = false;
      }
    },

    // 跳转到书籍详情页
    goToDetail (book) {
      console.log(book);
      const categoryParam = book.category.toLowerCase().replace(/\s+/g, '-');
      const titleParam = book.novelId ? book.novelId : book.title.toLowerCase().replace(/\s+/g, '-')
      console.log(book.novelId);
      const idParam = book.id;
      console.log(titleParam);
      console.log(`/${categoryParam}/${titleParam}/${idParam}`);
      this.$router.push(`/${categoryParam}/${titleParam}/${idParam}`);
    },

    // 将当前选中的分类滚动到可视区域 - 使用直接scrollLeft方式，去掉动画
    scrollActiveCategoryIntoView () {
      const categoryItems = this.$refs.categoryItems;
      if (!categoryItems) return;

      // 确定滚动的容器：移动端为父元素 (.category-nav-container)，PC端视情况而定
      const scrollContainer = this.deviceType === 'mobile' ? categoryItems.parentElement : categoryItems;
      if (!scrollContainer) return;

      // 强制禁用平滑滚动
      scrollContainer.style.scrollBehavior = 'auto';

      // 获取当前选中的分类元素
      const activeElement = categoryItems.querySelector(`.category-item[data-category="${this.activeCategory}"]`);
      if (!activeElement) return;

      // 使用 getBoundingClientRect 进行更稳健的计算
      const containerRect = scrollContainer.getBoundingClientRect();
      const activeRect = activeElement.getBoundingClientRect();

      // 计算滚动位置，使选中元素居中
      // 目标 scrollLeft = 当前 scrollLeft + (元素相对容器左边缘的距离) - (容器宽度的一半) + (元素宽度的一半)
      const relativeLeft = activeRect.left - containerRect.left;
      let scrollPosition = scrollContainer.scrollLeft + relativeLeft - (containerRect.width / 2) + (activeRect.width / 2);

      // 确保滚动不超出边界
      scrollPosition = Math.max(0, Math.min(scrollPosition, scrollContainer.scrollWidth - scrollContainer.clientWidth));

      // 直接设置scrollLeft
      scrollContainer.scrollLeft = scrollPosition;

      // 立即检查滚动位置
      this.checkScrollPosition();
    }
  }
}
</script>

<style lang="scss">
// 样式已移至 @/css/categories.scss
</style>
